import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { PANTERA } from 'HubStyleTokens/colors';
const StyledMediaBar = styled(UIMediaObject).withConfig({
  displayName: "MediaBar__StyledMediaBar",
  componentId: "sc-2uhuv6-0"
})(["padding:4px 0 4px 32px;background-color:", ";width:100%;"], PANTERA);

const MediaBar = ({
  children,
  onCopyValue,
  value = ''
}) => {
  return /*#__PURE__*/_jsx(StyledMediaBar, {
    itemRight: /*#__PURE__*/_jsx(UICopyButton, {
      use: "link-on-dark",
      className: "p-x-2",
      value: value,
      onClick: onCopyValue,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.codeSample.copyAll"
      })
    }),
    children: children
  });
};

export default MediaBar;